var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.com_user_type_access([2]))?_c('DashboardAffiliate',{attrs:{"msg":"Welcome to Dashboard ( Home )"}}):_c('Dashboard',{attrs:{"msg":"Welcome to Dashboard ( Home )"}})
}
var staticRenderFns = []

export { render, staticRenderFns }